export default __webpack_public_path__ + "media/images/home/slide_october_holiday_2026_lg-80c642417004fd58122131fd8d1ac2d3.jpg";